/* Tabs, FAQ accordion and scroll-filled timeline for snippets/eo-tabs.liquid (ported from the reference store). */
document.querySelectorAll('[data-eo-tabs]').forEach((root) => {

      const tabs = Array.from(root.querySelectorAll('[data-tab-trigger]'));
      const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));
      const timelinePanel = root.querySelector('[data-tab-panel="expect"]');
      const timelineSteps = Array.from(root.querySelectorAll('.tmtabs__panel--expect [data-step]'));
      const lineFill = root.querySelector('.tmtabs__panel--expect [data-line-fill]');
      const lineBase = root.querySelector('.tmtabs__panel--expect .tmtabs__line-base');
      const faqItems = Array.from(root.querySelectorAll('[data-faq-item]'));

      function setActiveTab(name) {
        tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', String(tab.dataset.tabTrigger === name));
        });

        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.tabPanel === name);
        });

        if (name === 'expect') {
          requestAnimationFrame(paintTimeline);
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setActiveTab(tab.dataset.tabTrigger);
        });
      });

      function getTimelineActiveIndex() {
        if (!timelinePanel || !timelinePanel.classList.contains('is-active')) return -1;

        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const stepTrigger = viewportHeight * 0.7;
        let activeIndex = -1;

        timelineSteps.forEach((step, index) => {
          const rect = step.getBoundingClientRect();
          const checkpoint = rect.top + Math.min(rect.height * 0.35, 24);
          if (checkpoint <= stepTrigger) activeIndex = index;
        });

        return activeIndex;
      }

     function getStepLineEnd(step, isLastActiveStep) {
  const node = step.querySelector('.tmtabs__node');
  if (!node || !lineBase) return 0;

  const nodeRect = node.getBoundingClientRect();
  const lineRect = lineBase.getBoundingClientRect();

  const nodeCenter = nodeRect.top + nodeRect.height / 2 - lineRect.top;
  const nodeBottom = nodeRect.bottom - lineRect.top;

  return isLastActiveStep ? nodeBottom - 1 : nodeCenter;
}
function paintTimeline() {
  if (!lineFill || !lineBase || !timelineSteps.length) return;

  const activeIndex = getTimelineActiveIndex();

  if (activeIndex < 0) {
    lineFill.style.height = '0px';
    timelineSteps.forEach((step) => step.classList.remove('is-active'));
    return;
  }

  const safeIndex = Math.min(activeIndex, timelineSteps.length - 1);
  const targetStep = timelineSteps[safeIndex];
  const isLastStep = safeIndex === timelineSteps.length - 1;
  const fillHeight = Math.max(getStepLineEnd(targetStep, isLastStep), 0);

  lineFill.style.height = `${fillHeight}px`;

  timelineSteps.forEach((step, index) => {
    step.classList.toggle('is-active', index <= safeIndex);
  });
}

      function setFaqState(item, open) {
        const trigger = item.querySelector('[data-faq-trigger]');
        const wrap = item.querySelector('[data-faq-wrap]');
        const answer = item.querySelector('[data-faq-answer]');
        if (!trigger || !wrap || !answer) return;

        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
        wrap.style.height = open ? `${answer.scrollHeight}px` : '0px';
      }

      faqItems.forEach((item) => {
  const trigger = item.querySelector('[data-faq-trigger]');
  if (!trigger) return;

  setFaqState(item, false);

  trigger.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');
    faqItems.forEach((faqItem) => setFaqState(faqItem, false));
    setFaqState(item, !isOpen);
  });
});

      let ticking = false;

      function onScrollOrResize() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          paintTimeline();
          faqItems.forEach((item) => {
            if (item.classList.contains('is-open')) {
              setFaqState(item, true);
            }
          });
          ticking = false;
        });
      }

      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);

      const defaultTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.tabTrigger || 'faq';
      setActiveTab(defaultTab);
    });
